<entitetikon [type]="avstemningEntitetType"/>
<div class="innhold">
  <div class="tittelrad">
    <div class="tittel" data-testid="tittel">{{ avstemning().tittel }}</div>
    @if (visAntallStemmerAvgitt()) {
      <c3-todelt-pai [andel]="avstemningsstatus().antallStemmerAvgittPerAvstemning[avstemning().id]"
                     [totalt]="avstemningsstatus().antallStemmeberettigedeDeltakere"
                     [konfig]="pieKonfig"
                     matTooltip="{{'{antall} av {totalt} stemmeberettigede har stemt'|translate:{antall: avstemningsstatus().antallStemmerAvgittPerAvstemning[avstemning().id], totalt: avstemningsstatus().antallStemmeberettigedeDeltakere} }}"/>
    }
    @if (medlemHarSkriveRolle()) {
      <button mat-icon-button [matMenuTriggerFor]="avstemningMeny" (click)="$event.stopPropagation()" aria-label="Meny" class="meny-trigger" data-testid="meny-knapp">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #avstemningMeny="matMenu" aria-label="{{'Avstemningmeny'|translate}}">
        @if (avstemningKanRedigeres()) {
          <button mat-menu-item (click)="rediger()">
            <mat-icon>edit</mat-icon>
            <span>{{ 'Rediger' | translate }}</span>
          </button>
          <button mat-menu-item [bekreftKlikk]="'Ja, slett avstemning' | translate" (klikk)="slett()">
            <mat-icon fontIcon="ion-ios-trash"></mat-icon>
            <span>{{ 'Slett' | translate }}</span>
          </button>
          <mat-divider/>
        }
        @if (medlemHarSkriveRolle() && !moeteLaastForRedigering()) {
          <button mat-menu-item [bekreftKlikk]="'Ja, slett stemmer' | translate" (klikk)="nullstillAvgitteStemmer()">
            <mat-icon fontIcon="ion-ios-trash"></mat-icon>
            <span>{{ 'Nullstill stemmer' | translate }}</span>
          </button>
        }
        @if (medlemHarSkriveRolle() && !moeteLaastForRedigering() && !avstemning().erAapenForAvstemning) {
          <button mat-menu-item (click)="aapneForAvstemning()">
            <mat-icon>play_circle</mat-icon>
            <span>{{ 'Åpne for avstemning' | translate }}</span>
          </button>
        }
        @if (medlemHarSkriveRolle() && !moeteLaastForRedigering() && avstemning().erAapenForAvstemning) {
          <button mat-menu-item (click)="stengeForAvstemning()">
            <mat-icon>stop_circle</mat-icon>
            <span>{{ 'Steng for avstemning' | translate }}</span>
          </button>
        }
        @if (medlemHarSkriveRolle() && !moeteLaastForRedigering() && !avstemning().erAapenForAvstemning) {
          <button mat-menu-item (click)="opprettBeslutning()">
            <mat-icon>edit</mat-icon>
            <span>{{ 'Opprett beslutning' | translate }}</span>
          </button>
        }
      </mat-menu>
    }
  </div>
  <html-formatert [innhold]="avstemning().beskrivelse" class="beskrivelse" data-testid="beskrivelse"/>

  @if (avstemning().erAapenForAvstemning) {
    <div class="svarskjema" [class.wmba-ikke_stemt]="harAvgittStemme()">
      @if (!avstemning().deltakerErStemmeberettiget) {
        <inline-melding data-testid="ikke-stemmeberettiget">{{ 'Du er ikke stemmeberettiget'|translate }}</inline-melding>
      }
      @else if (!harAvgittStemme()) {
        <inline-melding data-testid="ikke-stemt">{{ 'Du har ikke stemt på denne avstemningen'|translate }}</inline-melding>
      }
      <div class="tittel">
          {{ 'Avstemningsalternativer'|translate }}
      </div>
      <form (ngSubmit)="avgiStemme()" data-testid="stemmegivningsskjema">
        <mat-radio-group [formControl]="valgtAlternativ" [class.mangler-stemme]="brukerKanStemme() && !harAvgittStemme()">
          @for (alternativ of avstemning().avstemningsalternativer; track alternativ.id) {
            <mat-radio-button [value]="alternativ" [disabled]="!brukerKanStemme()" data-testid="alternativ">
              <span data-testid="alternativ-tittel">{{ alternativ.tittel }}</span>
            </mat-radio-button>
          }
        </mat-radio-group>
        @if (brukerKanStemme()) {
          <div class="handlinger">
            <button mat-raised-button color="primary" type="submit" [disabled]="valgtAlternativ.invalid || !erValgEndret() || arbeider()" data-testid="avgi-stemme">{{ 'Avgi stemme'|translate }}</button>
            @if (harAvgittStemme()) {
              <button mat-button color="warn" type="button" (click)="nullstillAvgittStemmeMedBekreftelse()">{{ 'Slett min stemme'|translate }}</button>
            }
          </div>
        }
      </form>
    </div>

  } @else {
    <div class="resultater" data-testid="resultater">
      <div class="tittel">
        @if (erAvstemningGjennomfoert()) {
          {{ 'Avstemningsresultat'|translate }}
        } @else {
          {{ 'Avstemningsalternativer (resultatet vises ikke før avstemning er gjennomført)'|translate }}
        }
      </div>
      <ul>
        @for (alternativ of avstemning().avstemningsalternativer; track alternativ.id) {
          <li data-testid="alternativ" [class.vinner]="alternativ.erVinner">
            <span data-testid="alternativ-tittel">{{ alternativ.tittel }}</span>
            <span data-testid="antall-stemmer">
              @if (erAvstemningGjennomfoert()) {
                ({{ (alternativ.antallStemmer === 1 ? '{count} stemme' : '{count} stemmer') | translate:{count: alternativ.antallStemmer} }})
              }
            </span>
          </li>
        }
      </ul>
    </div>
  }
</div>
